<template>
    <router-link :to="showCheckbox?'':'/videos/clip/' + clip.id" 
                 @click.native="check" 
                 class="clip-item" 
                 :class="{
                   'has-checkbox': showCheckbox, 
                   'unselected': !selected,
                   'selected': selected
                }" 
                 v-if="clip">
        <event-overlay :event="_event" :show-status="true"/>
        <div class="clip-preview" >
          <img :src="$hisport.absolute(clip.preview_url, {default:'/images/event_default.jpg', w: 640, q: 80, f: 'jpeg'})"  v-img-fallback="'/images/event_default.jpg'"/>
        </div>
        <div v-if="showCheckbox" class="clip-checkbox">
          <font-awesome-icon :icon="['fas','check']" size="6x" v-if="selected"/>
          <input type="checkbox" :checked="selected">
        </div>
        <div v-if="typeof onRemove == 'function'" class="clip-remove">
          <font-awesome-icon :icon="['fas','trash']" @click.stop.prevent="onRemove(clip.id, clip.event.id)"/>
        </div>
    </router-link>
</template>
<script>
import eventOverlay from "./event_overlay";
import { HELPERS }  from 'morpheos.hisport.vueplugin';
export default {
    components:{
      eventOverlay
    },
    props: {
      showCheckbox: {
        type: Boolean,
        default: false
      },
      selected: {
        type: Boolean,
        default: false
      },
      clip: {
        type: Object,
        default: function(){
            return null;
        }
      },
      event: {
        type: Object,
        default: function(){
            return null;
        }
      },
      onRemove: {
        type: Function,
        default: undefined
      }
    },
    methods:{
      check: function(){
        if(this.showCheckbox){
          this.$emit("input", !this.selected);
        }else{
          this.$router.push('/videos/clip/' + this.clip.id);
        }
      }
    },
    computed:{
      _event: function(){
        var evt = this.event || this.clip.event;
        var evt2 = {
          id: evt.id,
          title: evt.title,
          id_team_home: evt.id_team_home,
          id_team_foreign: evt.id_team_foreign,
          name_team_home: evt.name_team_home,
          name_team_foreign: evt.name_team_foreign,
          event_type: evt.event_type,
          timestamp: this.clip.created_at,
          video: {
            state: this.clip.state
          } 
        }
        return evt2;
      },
      url: function(){
        if(this.clip)
          return HELPERS.getVideoUrl(this.clip);
        return null;
      }
    }
}
</script>
<style scoped>

.clip-item{
   width:312px;
   height:184px;
   position:relative;
   border-radius:var(--border-radius);
   overflow:hidden;
   margin-bottom:20px;
   color: var(--white);
   z-index:0;
 }
.clip-item.has-checkbox.unselected{
  opacity:0.1;
}
.clip-item.has-checkbox.selected{
  opacity:0.8;
}
.clip-item .clip-checkbox input{
  display:none;
}
.clip-item .clip-checkbox{
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:100%;
  text-align:center;
  padding-top:45px;
}
.clip-item .clip-remove{
  position:absolute;
  top:10px;
  right:10px;
  padding:5px;
  text-align:center;
  color:red;
  z-index:2;
}
.clip-item .clip-remove:hover{
  background: red;
  color:white;
}

.clip-item.uploading{
    opacity: 0.5;
}
.clip-item.future{
    filter: grayscale(1);
}
.clip-item .clip-preview{
   width:100%;
   height:100%;
 }
.clip-item .clip-preview img,
.clip-item .clip-preview video{
   width:100%;
   height:100%;
 }
</style>